var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-switch",class:{
    'base-switch--is-dark': _vm.isDark,
  }},[_c('span',{staticClass:"switch-label d-inline-flex align-center"},[_vm._t("default")],2),_c('v-switch',{ref:"switchEl",attrs:{"value":_vm.checked,"input-value":_vm.value,"disabled":_vm.disabled,"ripple":false,"dense":"","flat":"","color":"blue","data-cy":"base-switch"},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }